import { render, staticRenderFns } from "./MoveBrandDialog.vue?vue&type=template&id=45c48b18&scoped=true"
import script from "./MoveBrandDialog.vue?vue&type=script&lang=js"
export * from "./MoveBrandDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveBrandDialog.vue?vue&type=style&index=0&id=45c48b18&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c48b18",
  null
  
)

export default component.exports